module.exports = __webpack_public_path__ + "static/media/optimize.f3e23d5d.webp";